import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { ClientScreeningCasesKey } from 'api/Clients/Types/ClientScreeningCasesDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

import { CompaniesFilterCell } from '../../Administration/Wallets/WalletsFilters'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const worldCheckCasesColumns: GridColumn[] = [
  {
    title: 'Case',
    field: ClientScreeningCasesKey.caseId,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.caseId) {
        return <td />
      }

      return <td>{props.dataItem.caseId}</td>
    },
    show: true,
    filterable: true,
    width: 180,
    filter: 'text',
  },
  {
    title: 'SystemCase',
    field: ClientScreeningCasesKey.systemCaseId,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.systemCaseId) {
        return <td />
      }

      return <td>{props.dataItem.systemCaseId}</td>
    },
    show: true,
    filterable: true,
    width: 180,
    filter: 'text',
  },
  {
    title: 'Status',
    field: ClientScreeningCasesKey.statusId,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => {
      if (!props.dataItem?.status?.name) {
        return <td />
      }

      return (
        <td align='center' style={{ textAlign: 'center' }}>
          {props.dataItem?.status?.name}
        </td>
      )
    },
    show: true,
    filterable: true,
    width: 100,
    minResizableWidth: 100,
    filter: 'text',
  },
  {
    title: 'On-Going',
    field: ClientScreeningCasesKey.ongoingScreening,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem?.ongoingScreeningEnabled} disabled />
        </td>
      )
    },
    show: true,
    filterable: true,
    width: 100,
    minResizableWidth: 100,
    filter: 'boolean',
  },
  {
    title: 'Latest Review',
    field: ClientScreeningCasesKey.latestReview,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem?.latestRequiredReviewDate)}
      </td>
    ),
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Created',
    field: ClientScreeningCasesKey.createdDate,
    filterCell: CompaniesFilterCell,
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem?.createdAt, true)}</td>
    ),
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Client',
    field: ClientScreeningCasesKey.clientName,
    cell: (props: GridCellProps) => (
      <td
        className='table-columns__content'
        style={{ color: 'var(--link)', textDecoration: 'underline' }}
      >
        <Link
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.client.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.client.name}
        </Link>
      </td>
    ),
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Entity',
    field: ClientScreeningCasesKey.tickmillCompany,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.client?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.client.tickmillCompany.id}>
            {props.dataItem.client.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    show: true,
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
]
